import React from 'react';
import { IoLogoYoutube, IoLogoInstagram, IoLocationOutline, IoCallOutline } from 'react-icons/io5';
import './Footer.css';

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="footer-tiktok-icon">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const footerLinks = {
  lembaga: {
    title: 'Lembaga',
    links: [
      { label: 'Pondok Pesantren', href: '/about#lembaga' },
      { label: 'MTS Plus', href: '/about#lembaga' },
      { label: 'SMA Plus', href: '/about#lembaga' },
    ],
  },
  program: {
    title: 'Program',
    links: [
      { label: 'Tahfidz', href: '/#programs' },
      { label: 'Kitab Kuning', href: '/#programs' },
      { label: 'Bahasa', href: '/#programs' },
      { label: 'Kepemimpinan', href: '/#programs' },
    ],
  },
  tautan: {
    title: 'Tautan',
    links: [
      { label: 'Tentang', href: '/about' },
      { label: 'Berita', href: '/blog' },
      { label: 'PSB', href: '/admission' },
    ],
  },
};

const socialLinks = [
  {
    href: 'https://www.youtube.com/@islamiccentretvBangka',
    icon: IoLogoYoutube,
    label: 'YouTube',
  },
  {
    href: 'https://www.instagram.com/official_bahrululumsungailiat',
    icon: IoLogoInstagram,
    label: 'Instagram',
  },
  {
    href: 'https://www.tiktok.com/@icmedia20',
    icon: TikTokIcon,
    label: 'TikTok',
  },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand">
            <div>
              <h3 className="footer-brand-title">Bahrul Ulum</h3>
              <p className="footer-brand-desc">
                Membentuk generasi unggul yang cerdas, berdaya saing, dan
                berakhlak mulia melalui pendidikan terpadu Islami.
              </p>
            </div>

            <div className="footer-contact">
              <a 
                href="https://maps.app.goo.gl/eqouCgMVTc8SCf366"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-item footer-contact-link"
              >
                <IoLocationOutline className="footer-contact-icon" />
                <span>Sungailiat, Bangka - Indonesia</span>
              </a>
              <div className="footer-contact-item">
                <IoCallOutline className="footer-contact-icon" />
                <span>+62 831-5793-8748</span>
              </div>
            </div>

            {/* Map Preview */}
            <div className="footer-map">
              <iframe
                src="https://maps.google.com/maps?q=Pondok+Pesantren+Bahrul+Ulum+Sungailiat&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="180"
                style={{ border: 0, borderRadius: '0.75rem' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Lokasi Bahrul Ulum"
              />
            </div>
          </div>

          {/* Links Columns */}
          <div className="footer-links">
            {Object.entries(footerLinks).map(([key, section]) => (
              <div key={key}>
                <h4 className="footer-links-title">{section.title}</h4>
                <ul className="footer-links-list">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a href={link.href} className="footer-link">
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Social Column */}
          <div className="footer-social">
            <h4 className="footer-links-title">Media Sosial</h4>
            <div className="footer-social-links">
              {socialLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                >
                  <span className="footer-social-icon">
                    <link.icon />
                  </span>
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Yayasan Bahrul Ulum. All rights reserved.
          </p>
          <p className="footer-location">
            Islamic Centre Sungailiat
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
